import React, { FC, ReactElement } from 'react'
import { Alert } from 'antd'
import { FeeUpdatedAlertProps } from './types'
import './styles.modules.scss'

export const FeeUpdatedAlert: FC<FeeUpdatedAlertProps> = ({ fee }): ReactElement => {
  return (
    <Alert
      message={`Fee updated to ${fee} based on state.`}
      type="info"
      closable
      showIcon
      className="fee-updated-alert"
    />
  )
}
